// import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { getQueryParams } from '../../utils/common';
import makeRequest from '../../utils/makeRequest';

const ArticleShowWidgetWrapper = props => {
  const { Widget, classes, styles, defaultprops, url } = props;
  const [widgetData, setwidgetData] = useState({}); // integer state
  const msid = getQueryParams('msid', { href: url });
  const isPrime = getQueryParams('isPrime', { href: url });
  const stryno = getQueryParams('stryno', { href: url });

  const getAsbriefData = () => {
    makeRequest
      .get(
        `https://timesofindia.indiatimes.com/feeds/asbriefnewslistingfeed/feedtype-sjson,msid-81950662,tag-alrt,uid-Briefs-01,type-brief,stryno-${stryno},excludemsid-${msid}.cms`,
      )
      .then(response => {
        if (response && response.status === 200 && response.data) {
          delete response.data.items[3];
          setwidgetData({
            data: response.data,
          });
        }
      });
  };
  if (!widgetData.data) {
    getAsbriefData();
  }
  return (
    <>
      {widgetData.data ? (
        <div style={styles} className={classes}>
          <Widget
            {...defaultprops}
            {...props}
            url={url}
            asSectionName="INDIA"
            asBriefsData={widgetData.data}
            asHeading="ELECTION BRIEFS"
            isUserPrime={isPrime}
          />
        </div>
      ) : null}
    </>
  );
};

export default ArticleShowWidgetWrapper;
